import * as api from './categories';

export default api;
export * from './categories';
